'use es6';

import Actions from 'AdsUI/lib/Actions';
import { List } from 'immutable';
import UsersInfoRecord from 'AdsUI/records/users/UsersInfoRecord';
export default ((state = List(), action) => {
  const {
    type,
    payload
  } = action;

  if (!payload) {
    return state;
  }

  switch (type) {
    case Actions.USERS_INFO_FETCH_SUCCEEDED:
      return List(payload.map(e => new UsersInfoRecord(e)));

    default:
      return state;
  }
});